import React from 'react';
import { useSelector } from 'react-redux';
import { NoItemsYet } from 'components';
import { Images } from 'utils';
import { TargetMaintenance } from 'fragments/client/clientSingle/clientClinical/goals/mastery/targetMaintenance';
import { GoalMasteryCard, TargetMasteryCard } from 'fragments/client/clientSingle/clientClinical/goals/mastery/masteryOption';

export const LibraryGoalMastery = () => {
    const { goalById } = useSelector((state) => ({
        goalById: state.library.goalById,
    }));

    if (!goalById?.goalMastery?._id && !goalById?.targetMastery?._id) {
        return <NoItemsYet text={'No Mastery Yet'} image={Images.emptyFolder} />;
    }

    return (
        <div>
            {goalById?.targetMastery?._id && <TargetMasteryCard goalById={goalById} isLibrary />}
            {goalById?.goalMastery?._id && <GoalMasteryCard goalById={goalById} isLibrary />}
            <TargetMaintenance isLibrary />
        </div>
    );
};
